(()=>{'use strict';const root=document.getElementById('cw-bb-landing');if(!root||root.dataset.initialized)return;root.dataset.initialized='true';
const stockBundle = {
  "verifiedOn": "2026-09-21",
  "handle": "baseball-camwood-elite-60-days-baseball-hands-speed-trainer-one-hand-trainer",
  "price": 12700,
  "membershipVariant": 60788385153394,
  "sellingPlan": 694304899442,
  "variants": [
    {
      "id": 60846091764082,
      "title": "26 Inch - 32 Ounce",
      "available": true,
      "price": 12700
    },
    {
      "id": 60846091895154,
      "title": "27 Inch - 33 Ounce",
      "available": true,
      "price": 12700
    },
    {
      "id": 60846091927922,
      "title": "28 Inch - 34 Ounce",
      "available": true,
      "price": 12700
    },
    {
      "id": 60846091960690,
      "title": "29 Inch - 35 Ounce",
      "available": true,
      "price": 12700
    },
    {
      "id": 60846091993458,
      "title": "30 Inch - 36 Ounce",
      "available": true,
      "price": 12700
    },
    {
      "id": 60846092026226,
      "title": "31 Inch - 37 Ounce ( Youth )",
      "available": true,
      "price": 12700
    },
    {
      "id": 60846092058994,
      "title": "31 Inch - 43 Ounce ( Adult )",
      "available": true,
      "price": 12700
    },
    {
      "id": 60846092091762,
      "title": "32 Inch - 44 Ounce",
      "available": true,
      "price": 12700
    },
    {
      "id": 60846092124530,
      "title": "33 Inch - 45 Ounce",
      "available": true,
      "price": 12700
    },
    {
      "id": 60846092157298,
      "title": "34 Inch - 46 Ounce",
      "available": true,
      "price": 12700
    }
  ]
};

// Snapshot for the local preview. Refresh availability before Shopify integration.
// The live theme pairs this bundle with ONE baseball membership per cart.
// Its free-program companion rules do not apply to this bundle handle.
function getStockVariant(id) {
 const variant=stockBundle.variants.find(v=>String(v.id)===String(id));
 if(!variant) throw new Error('Choose your player’s trainer size.');
 if(!variant.available) throw new Error('That size is sold out. Choose another size.');
 return variant;
}
function buildStockCartPayload(id, cartItems=[]) {
 const variant=getStockVariant(id);
 const items=[{id:variant.id,quantity:1}];
 const memberLines=cartItems.filter(item=>Number(item.variant_id)===stockBundle.membershipVariant);
 if(memberLines.some(item=>Number(item.selling_plan_allocation?.selling_plan?.id)!==stockBundle.sellingPlan)) {
  throw new Error('Your existing membership needs to be reviewed on the product page.');
 }
 if(!memberLines.length) items.push({id:stockBundle.membershipVariant,quantity:1,selling_plan:stockBundle.sellingPlan});
 return {items};
}

// Loaded only in the approved Shopify template. Preview keeps its simulated cart.
function installLiveCart({root, stockBundle, getStockVariant, buildStockCartPayload, fetcher=window.fetch.bind(window)}) {
 const form=root.querySelector('#stock-form');
 const size=root.querySelector('#stock-size');
 const button=root.querySelector('#stock-add');
 const status=root.querySelector('#stock-status');
 const dialog=root.querySelector('#cart-dialog');
 const route=window.Shopify?.routes?.root||'/';
 let busy=false, addedId=null, uncertain=false;
 async function read(path){
  const response=await fetcher(route+path,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
  if(!response.ok)throw new Error('We could not check your cart. Please try again.');
  return response.json();
 }
 const quantity=(cart,id)=>cart.items.filter(i=>Number(i.variant_id)===Number(id)).reduce((n,i)=>n+i.quantity,0);
 function confirm(variant){
  addedId=String(variant.id);uncertain=false;
  root.querySelector('#cart-size').textContent=variant.title;
  status.textContent='Added to your cart: '+variant.title;
  button.textContent='View Cart & Checkout →';
  window.BoosterTheme?.cart?.close?.();
  document.querySelectorAll('[data-minicart-input]').forEach(input=>{input.checked=false;});
  dialog.showModal();document.body.classList.add('shopping-dialog-open');
 }
 form.addEventListener('submit',async event=>{
  event.preventDefault();
  if(busy||!form.reportValidity())return;
  if(uncertain||addedId===size.value){window.location.assign(route+'cart');return;}
  busy=true;button.disabled=true;size.disabled=true;
  button.textContent='Adding to Cart…';status.textContent='';
  let attempted=false;
  try{
   const selected=getStockVariant(size.value);
   const [product,memberProduct,cart]=await Promise.all([
    read('products/'+stockBundle.handle+'.js'),
    read('products/baseball-camwood-elite-membership-60-days.js'),
    read('cart.js')
   ]);
   for(const option of size.options){
    if(option.value)option.disabled=!product.variants.some(v=>String(v.id)===option.value&&v.available);
   }
   const variant=product.variants.find(v=>v.id===selected.id);
   if(!variant?.available)throw new Error('That size just sold out. Please choose another size.');
   if(variant.price!==stockBundle.price||cart.currency!=='USD')throw new Error('Please open the product page below to see current pricing.');
   const member=memberProduct.variants.find(v=>v.id===stockBundle.membershipVariant);
   const plan=member?.selling_plan_allocations?.find(p=>p.selling_plan_id===stockBundle.sellingPlan);
   if(!member?.available||!plan||plan.price!==0||plan.price_adjustments?.[1]?.price!==9700)throw new Error('Please open the product page below to review the current membership offer.');
   const payload=buildStockCartPayload(variant.id,cart.items);
   attempted=true;
   const response=await fetcher(route+'cart/add.js',{
    method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)
   });
   const result=await response.json();
   // Check the actual cart even on a 422: inventory errors can partially add items.
   const after=await read('cart.js');
   const validMember=after.items.some(i=>i.variant_id===stockBundle.membershipVariant&&i.selling_plan_allocation?.selling_plan?.id===stockBundle.sellingPlan);
   if(quantity(after,variant.id)>quantity(cart,variant.id)&&validMember){confirm(variant);return;}
   throw new Error(response.ok?'We could not confirm your complete bundle. Review your cart before continuing.':(result.description||'We could not add the complete bundle. Review your cart before trying again.'));
  }catch(error){
   uncertain=attempted;
   status.textContent=attempted?'Please review your cart before trying again. Your items may already have been added.':error.message;
   button.textContent=attempted?'Review Your Cart →':'Add to Cart — $127 →';
  }finally{
   busy=false;button.disabled=false;size.disabled=false;
  }
 });
 size.addEventListener('change',()=>{
  button.textContent=uncertain?'Review Your Cart →':addedId===size.value?'View Cart & Checkout →':'Add to Cart — $127 →';
  status.textContent='';
 });
}


root.querySelectorAll('[data-scroll]').forEach(button=>button.addEventListener('click',()=>document.getElementById(button.dataset.scroll)?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
const dialog=document.getElementById('video-dialog');
const embed=document.getElementById('video-embed');
root.querySelectorAll('[data-youtube]').forEach(button=>button.addEventListener('click',()=>{
 const iframe=document.createElement('iframe');iframe.src='https://www.youtube-nocookie.com/embed/'+button.dataset.youtube+'?autoplay=1';iframe.title=button.getAttribute('aria-label');iframe.allow='autoplay; encrypted-media; picture-in-picture';iframe.allowFullscreen=true;embed.replaceChildren(iframe);dialog.showModal();
}));
dialog.querySelector('button').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
dialog.addEventListener('close',()=>embed.replaceChildren());
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
const cwVids=[...root.querySelectorAll('video')];
if(reduced.matches||!('IntersectionObserver' in window)){
 cwVids.forEach(video=>video.setAttribute('controls',''));
}else{
 const cwWarm=new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting})=>{
  if(!isIntersecting)return;
  if(!target.dataset.cwWarm&&target.paused&&target.currentTime===0){target.dataset.cwWarm='1';target.preload='auto';try{target.load();}catch(_){}}
  cwWarm.unobserve(target);
 }),{rootMargin:'600px 0px'});
 const observer=new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting})=>{
  if(isIntersecting){
   target.muted=true;
   const played=target.play();
   if(played&&played.catch)played.catch(()=>{
    target.dataset.cwFail=(+target.dataset.cwFail||0)+1;
    if(+target.dataset.cwFail>1)target.setAttribute('controls','');
   });
  }else if(!target.paused)target.pause();
 }),{threshold:.2,rootMargin:'10% 0px'});
 cwVids.forEach(video=>{video.muted=true;video.loop=true;video.setAttribute('playsinline','');video.removeAttribute('controls');observer.observe(video);});
 // perf 2026-09-24: pre-buffer upcoming videos only after the page has loaded, so they never compete with first paint.
 const cwStartWarm=()=>setTimeout(()=>cwVids.forEach(video=>cwWarm.observe(video)),250);
 if(document.readyState==='complete')cwStartWarm();else window.addEventListener('load',cwStartWarm,{once:true});
}

const stockForm=document.getElementById('stock-form');
const cartDialog=document.getElementById('cart-dialog');
const sizeDialog=document.getElementById('size-dialog');
root.querySelector('[data-size-guide]').addEventListener('click',()=>sizeDialog.showModal());
root.querySelectorAll('.shopping-dialog').forEach(modal=>{
 modal.querySelectorAll('[data-close-dialog]').forEach(button=>button.addEventListener('click',()=>modal.close()));
 modal.addEventListener('click',event=>{
  const rect=modal.getBoundingClientRect();
  if(event.target===modal&&(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom))modal.close();
 });
 modal.addEventListener('close',()=>document.body.classList.remove('shopping-dialog-open'));
});
root.querySelectorAll('[data-size-guide],#stock-form').forEach(element=>element.addEventListener(element===stockForm?'submit':'click',()=>{
 if(cartDialog.open||sizeDialog.open)document.body.classList.add('shopping-dialog-open');
}));
// Avoid covering the purchase controls with a second CTA while comparing bundles.
const offerObserver=new IntersectionObserver(entries=>{
 root.querySelector('.mobile-cta').classList.toggle('is-hidden',entries[0].isIntersecting);
},{threshold:0});
offerObserver.observe(root.querySelector('.offer'));

installLiveCart({root,stockBundle,getStockVariant,buildStockCartPayload});
})();